import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { useState, useEffect } from "react";

export default function GoalsDialog({ open, onOpenChange, goals, onSave }) {
  const [form, setForm] = useState(goals);

  useEffect(() => {
    if (open) setForm(goals);
  }, [open, goals]);

  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = () => {
    onSave({
      calories: Math.max(500, Number(form.calories) || 0),
      protein_g: Math.max(0, Number(form.protein_g) || 0),
      carbs_g: Math.max(0, Number(form.carbs_g) || 0),
      fats_g: Math.max(0, Number(form.fats_g) || 0),
      water_ml: Math.max(500, Number(form.water_ml) || 0),
      body_weight_kg: Math.max(20, Number(form.body_weight_kg) || 0),
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="goals-dialog">
        <DialogHeader>
          <DialogTitle data-testid="goals-dialog-title">Customize Daily Goals</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 pt-2">
          <p className="text-sm text-gray-600 dark:text-gray-400" data-testid="goals-dialog-description">
            Set the calorie and macro targets that match your training plan.
          </p>
          <div>
            <Label htmlFor="g-cal" className="text-xs font-medium">Calories (kcal)</Label>
            <Input
              id="g-cal" type="number" min="500" max="10000"
              value={form.calories ?? ""}
              onChange={(e) => upd("calories", e.target.value)}
              data-testid="goal-calories-input"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div>
              <Label htmlFor="g-p" className="text-xs font-medium">Protein (g)</Label>
              <Input id="g-p" type="number" min="0" max="1000"
                value={form.protein_g ?? ""}
                onChange={(e) => upd("protein_g", e.target.value)}
                data-testid="goal-protein-input"
              />
            </div>
            <div>
              <Label htmlFor="g-c" className="text-xs font-medium">Carbs (g)</Label>
              <Input id="g-c" type="number" min="0" max="1500"
                value={form.carbs_g ?? ""}
                onChange={(e) => upd("carbs_g", e.target.value)}
                data-testid="goal-carbs-input"
              />
            </div>
            <div>
              <Label htmlFor="g-f" className="text-xs font-medium">Fats (g)</Label>
              <Input id="g-f" type="number" min="0" max="500"
                value={form.fats_g ?? ""}
                onChange={(e) => upd("fats_g", e.target.value)}
                data-testid="goal-fats-input"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label htmlFor="g-w" className="text-xs font-medium">Water (ml)</Label>
              <Input id="g-w" type="number" min="500" max="15000"
                value={form.water_ml ?? ""}
                onChange={(e) => upd("water_ml", e.target.value)}
                data-testid="goal-water-input"
              />
            </div>
            <div>
              <Label htmlFor="g-bw" className="text-xs font-medium">Body weight (kg)</Label>
              <Input id="g-bw" type="number" min="20" max="500" step="0.1"
                value={form.body_weight_kg ?? ""}
                onChange={(e) => upd("body_weight_kg", e.target.value)}
                data-testid="goal-weight-input"
              />
            </div>
          </div>

          <p className="text-[11px] text-gray-500">
            Body weight is used to estimate calories burned during exercise.
          </p>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="goals-cancel-btn">Cancel</Button>
          <Button onClick={save} className="bg-emerald-600 hover:bg-emerald-700" data-testid="goals-save-btn">
            Save Goals
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
